import Axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { API_BASE_URL } from "../config";

interface AdaptAxiosRequestConfig extends AxiosRequestConfig {
  headers: AxiosRequestHeaders;
}

function authRequestInterceptor(config: AdaptAxiosRequestConfig) {
  if (config.url && config.url.includes("authentication/referrer/validate")) {
    const referrer_token = localStorage.getItem('referrer_token')
    config.headers['X-Referrer-Token'] = referrer_token;
  }
  
  const token = localStorage.getItem('jwt_token')
  config.headers['X-Auth-Token'] = token;
  config.headers.Accept = "application/json";
  return config;
}

const axiosTranont = Axios.create({
  baseURL: API_BASE_URL,
});

axiosTranont.interceptors.request.use(authRequestInterceptor);
axiosTranont.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    return Promise.reject(error);
  }
);

export { axiosTranont };
